import { CloseCircleOutlined } from "@ant-design/icons";
import { Result, Typography } from "antd";
import React from "react";
import {
  BrowserRouter,
  Routes as RouterRoutes,
  Route,
  Navigate,
} from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import App from "./app/App";
import { ERROR_PAGE_SUBTITLE, ERROR_PAGE_TITLE } from "./common/constants";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgetPassword";
import ResetPassword from "./pages/auth/ResetPassword";

const { Paragraph } = Typography;

const MyFallbackComponent = ({ error, componentStack }) => (
  <Result
    status="error"
    title={ERROR_PAGE_TITLE}
    subTitle={ERROR_PAGE_SUBTITLE}
  >
    <div className="desc">
      <Paragraph>
        <Typography.Title level={4}> Error:</Typography.Title>
      </Paragraph>
      <Paragraph>
        <CloseCircleOutlined className="site-result-demo-error-icon" /> Your
        {error?.message?.toString()}
      </Paragraph>
      <Paragraph>
        <Typography.Title level={4}> Stacktrace:</Typography.Title>
      </Paragraph>
      <Paragraph>
        <CloseCircleOutlined className="site-result-demo-error-icon" /> Your
        {componentStack}
      </Paragraph>
    </div>
  </Result>
);

const Routes = () => {

  const VERSION = require("../package.json")?.version;

  console?.log("APP_VERSION ", VERSION);

  return (
    <BrowserRouter>
      <RouterRoutes>
        {/* Root redirect to login */}
        {/* <Route path="/" element={<Navigate to="/login" replace />} /> */}

        {/* Public Route - Login */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />

        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />

        {/* Private Route - Main App with nested routes */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <App />
            </PrivateRoute>
          }
        />

        {/* 404 Fallback */}
        {/* <Route path="*" element={<MyFallbackComponent />} /> */}
      </RouterRoutes>
    </BrowserRouter>
  );
};

export default Routes;
